'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Login = require('../../helpers/Login');

var _Logs = require('../../helpers/Logs');

var _PopupType = require('../../helpers/PopupType');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _SessionStorage = require('../../helpers/SessionStorage');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _AuthorizationOptions = require('./AuthorizationOptions.scss');

var _AuthorizationOptions2 = _interopRequireDefault(_AuthorizationOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorizationOptions = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo, auth: state.auth, log: state.log };
}, { changePopupType: _popup.changePopupType, linkSSOToken: _auth.linkSSOToken, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AuthorizationOptions, _Component);

  function AuthorizationOptions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AuthorizationOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthorizationOptions.__proto__ || (0, _getPrototypeOf2.default)(AuthorizationOptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      provider: null,
      token: '',
      iframe: false,
      timeReceivedToken: null
    }, _this.onLinkSSOTokenSuccess = function (props) {
      (0, _Logs.logNavigationSSO)('', _Logs.LogName.AuthorizationSSOSuccess, (0, _Logs.createEventSelectedOption)(_Logs.LogEventSelectedOptions.Success), props.log, props.auth, props.appInfo);
      props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.AuthorizationSSOSuccess));
    }, _this.onSSO = function () {
      (0, _Logs.logNavigationPopup)(_Logs.LogName.AuthorizationOptions, _Logs.LogName.SSOProvider, _this.props.log, _this.props.auth, _this.props.appInfo);
      (0, _Logs.logNavigationSSO)(_Logs.LogName.AuthorizationOptions, _Logs.LogName.SSOProvider, (0, _Logs.createEventSelectedOption)(_Logs.LogEventSelectedOptions.Attempts, ['operatorId'], [_this.state.provider.id]), _this.props.log, _this.props.auth, _this.props.appInfo);
      _this.handleIframeState();
    }, _this.onMobile = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.AuthorizationNow));
    }, _this.receiveMessage = function (event) {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (event.data.token) {
        var token = event.data.token;
        if (event.data.operatorId === _this.state.provider.id) {
          _this.setState({ timeReceivedToken: new Date().getTime() });
          _this.props.linkSSOToken(token, _this.state.provider.id);
        }
      }
    }, _this.handleIframeState = function () {
      _this.setState({ iframe: !_this.state.iframe });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AuthorizationOptions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var provider = (0, _Provider.getProviderFromStorage)(_SessionStorage.SessionStorageKeys.SelectedProviderKey);
      this.setState({ provider: provider });

      window.addEventListener('message', this.receiveMessage, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.auth.linkingSSOToken && !nextProps.auth.linkingSSOToken) {
        if (nextProps.auth.error || !nextProps.auth.userInfo) {
          this.setState({ iframe: false });
          (0, _Logs.logNavigationSSO)('', '', (0, _Logs.createEventSelectedOption)(_Logs.LogEventSelectedOptions.Fail, ['operatorId', 'error'], [this.state.provider.id, nextProps.auth.error]), this.props.log, this.props.auth, this.props.appInfo);
          this.props.changePopupType(_PopupType.PopupId.UnknownError);
        } else {
          var currentTime = new Date().getTime();

          if (this.state.timeReceivedToken < currentTime + AuthorizationOptions.waitTimeMs) {
            this.onLinkSSOTokenSuccess(nextProps);
          } else {
            var remainingTimeMs = AuthorizationOptions.waitTimeMs - (currentTime - this.state.timeReceivedToken);
            setTimeout(function () {
              _this2.onLinkSSOTokenSuccess(nextProps);
            }, remainingTimeMs);
          }
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.receiveMessage, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var hasSSO = this.state.provider && this.state.provider.loginMode.find(function (loginMode) {
        return loginMode === _Login.LoginMode.SSO;
      }) && this.state.provider.loginUrlWithRedirect;
      var hasIframe = this.state.iframe && this.state.provider;
      return _react2.default.createElement(
        'div',
        { className: _AuthorizationOptions2.default.authorizationOptions },
        _react2.default.createElement(
          'div',
          { className: _AuthorizationOptions2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Authorization)
        ),
        _react2.default.createElement(_components.ProviderLogo, { className: _AuthorizationOptions2.default.providerLogo, provider: this.state.provider }),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationOptions2.default.message },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.AuthorizationOptionsMessage)
        ),
        _react2.default.createElement(_components.BaseButton, { className: _AuthorizationOptions2.default.button, onClick: function onClick() {
            return _this3.onMobile();
          }, buttonString: _DefaultString.translations.AuthorizationWithMobile }),
        hasSSO ? _react2.default.createElement(_components.BaseButton, {
          className: _AuthorizationOptions2.default.button,
          onClick: function onClick() {
            return _this3.onSSO();
          },
          buttonString: _DefaultString.translations.AuthorizationWithProvider,
          buttonStringValue: { provider: this.state.provider ? this.state.provider.name : '' }
        }) : '',
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'fadeInOutPopup',
            transitionEnterTimeout: 300,
            transitionLeaveTimeout: 300
          },
          hasIframe ? _react2.default.createElement(_components.SSOLoginIframe, { close: this.handleIframeState, provider: this.state.provider }) : ''
        )
      );
    }
  }]);
  return AuthorizationOptions;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  linkSSOToken: _react.PropTypes.func,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _class2.waitTimeMs = 300, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(AuthorizationOptions);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationOptions/AuthorizationOptions.js
// module id = 1998
// module chunks = 0